import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import PropTypes from "prop-types";
import cx from "classnames";
import Swal from "sweetalert2";
import { CurrencyTiktok } from "helper/constant";

function Main() {
    const [settings, setSettings] = useState(localStorage.getItem("extension_settings") ? JSON.parse(localStorage.getItem("extension_settings")) : {});
    const [tab, setTab] = useState("general");
    const { t } = useTranslation();

    const onChange = (e) => {
        var settings_tmp = { ...settings };
        if (!settings_tmp[tab]) {
            settings_tmp[tab] = {};
        }
        if (!settings_tmp[tab][e.target.name]) {
            settings_tmp[tab][e.target.name] = "";
        }
        settings_tmp[tab][e.target.name] = e.target.value;

        setSettings(settings_tmp);
    };

    const onClick = (data) => {
        setTab(data);
    };

    const onClickSaveEdit = () => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Are you sure to save changes?"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("Sure"),
            cancelButtonText: t("Cancel")
        }).then((result) => {
            if (result.value) {
                localStorage.setItem("extension_settings", JSON.stringify(settings));
                Swal.fire(t("Success"), t("Change settings successfully!"), 'success');
            }
        })
    };

    const onClickDeleteAllDataExtension = () => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Are you sure to delete all data extension?"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("Sure"),
            cancelButtonText: t("Cancel")
        }).then((result) => {
            if (result.value) {
                localStorage.removeItem("extension_drop_list_1688");
                localStorage.removeItem("extension_drop_list_alibaba");
                localStorage.removeItem("extension_drop_list_aliexpress");
                localStorage.removeItem("extension_drop_list_amazon");
                localStorage.removeItem("extension_drop_list_cj");
                localStorage.removeItem("extension_drop_list_ebay");
                localStorage.removeItem("extension_drop_list_other");
                localStorage.removeItem("extension_drop_list_shein");
                localStorage.removeItem("extension_drop_list_shopee");
                localStorage.removeItem("extension_drop_list_taobao");
                localStorage.removeItem("extension_drop_list_temu");
                localStorage.removeItem("extension_drop_list_thgfulfill");
                localStorage.removeItem("extension_drop_list_tiktok");
                localStorage.removeItem("extension_drop_list_walmart");

                localStorage.removeItem("extension_listalibaba");
                localStorage.removeItem("extension_listaliexpress");
                localStorage.removeItem("extension_listamazon");
                localStorage.removeItem("extension_listebay");
                localStorage.removeItem("extension_listetsy");
                localStorage.removeItem("extension_listgoogle");
                localStorage.removeItem("extension_listother");
                localStorage.removeItem("extension_listpinterest");
                localStorage.removeItem("extension_listredbubble");
                localStorage.removeItem("extension_listshein");
                localStorage.removeItem("extension_listshopify");
                localStorage.removeItem("extension_listtemu");
                localStorage.removeItem("extension_listtiktok");
                localStorage.removeItem("extension_listwalmart");
                localStorage.removeItem("extension_listwoocommerce");
                localStorage.removeItem("extension_listzazzle");

                Swal.fire(t("Success"), t("Delete all data extension successfully!"), 'success');
            }
        })
    };

    return (
        <Fragment>
            <div className="card mb-5 mb-xl-10">
                <div className="card-body pt-0 pb-0">
                    <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                        <li className="nav-item mt-2">
                            <Link className={cx("nav-link text-active-primary ms-0 me-10 py-5", { active: tab === "general" })} to="/admin/extension-settings" onClick={(e) => { onClick("general"); }}>
                                {t("General")}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card mb-5 mb-xl-10">
                <div id="kt_account_settings_profile_details" className="collapse show">
                    <div className="card-body border-top p-9">
                        {
                            tab === "general" ?
                                <Fragment>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Filter duplicate products")}</span>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="filter_duplicate_products_1" name="filter_duplicate_products" checked={settings?.["general"]?.filter_duplicate_products === "1"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="filter_duplicate_products_1">{t("Yes")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="filter_duplicate_products_0" name="filter_duplicate_products" checked={settings?.["general"]?.filter_duplicate_products === "0" || typeof settings?.["general"]?.filter_duplicate_products === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="filter_duplicate_products_0">{t("No")}</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Get price product")}</span>
                                            <div className="form-text">aliexpress, amazon, shein</div>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="get_price_product_0" name="get_price_product" checked={settings?.["general"]?.get_price_product === "0" || typeof settings?.["general"]?.get_price_product === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="get_price_product_0">{t("Original Price")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="get_price_product_1" name="get_price_product" checked={settings?.["general"]?.get_price_product === "1"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="get_price_product_1">{t("Sale Price")}</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Crawl type")}</span>
                                            <div className="form-text">amazon, shein, ulta</div>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="crawl_type_0" name="crawl_type" checked={settings?.["general"]?.crawl_type === "0" || typeof settings?.["general"]?.crawl_type === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_type_0">{t("All Variants")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="crawl_type_1" name="crawl_type" checked={settings?.["general"]?.crawl_type === "1"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_type_1">{t("Only 1 Variant")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="2" id="crawl_type_2" name="crawl_type" checked={settings?.["general"]?.crawl_type === "2"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_type_2">{t("Only Hot Variant (Shein)")}</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Currency exchange to")}</span>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <select className="form-select" name="currency_exchange_to" onChange={(e) => { onChange(e) }} value={settings?.["general"]?.currency_exchange_to || "USD"}>
                                                {Object.keys(CurrencyTiktok).map((key) => (
                                                    <option value={key}>{CurrencyTiktok[key]}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Popup button")}</span>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="popup_button_1" name="popup_button" checked={settings?.["general"]?.popup_button === "1" || typeof settings?.["general"]?.popup_button === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="popup_button_1">{t("Enable")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="popup_button_0" name="popup_button" checked={settings?.["general"]?.popup_button === "0"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="popup_button_0">{t("Disable")}</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Crawl tab")}</span>
                                            <div className="form-text">aliexpress, amazon, ebay, other, shein, temu, tiktok, walmart</div>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="crawl_tab_0" name="crawl_tab" checked={settings?.["general"]?.crawl_tab === "0" || typeof settings?.["general"]?.crawl_tab === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_tab_0">{t("All Tabs")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="crawl_tab_1" name="crawl_tab" checked={settings?.["general"]?.crawl_tab === "1"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_tab_1">{t("Only Dropshipping Tab")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="2" id="crawl_tab_2" name="crawl_tab" checked={settings?.["general"]?.crawl_tab === "2"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_tab_2">{t("Only POD Tab")}</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-6">
                                        <label className="col-lg-2 col-form-label fw-semibold fs-6">
                                            <span className="">{t("Crawl number of images")}</span>
                                            <div className="form-text">amazon</div>
                                        </label>
                                        <div className="col-lg-10 m-auto">
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="0" id="crawl_number_of_images_0" name="crawl_number_of_images" checked={settings?.["general"]?.crawl_number_of_images === "0" || typeof settings?.["general"]?.crawl_number_of_images === "undefined"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_number_of_images_0">{t("Max 9 images")}</label>
                                            </span>
                                            <span className="me-10">
                                                <input className="form-check-input me-3" type="radio" value="1" id="crawl_number_of_images_1" name="crawl_number_of_images" checked={settings?.["general"]?.crawl_number_of_images === "1"} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="crawl_number_of_images_1">{t("All images")}</label>
                                            </span>
                                        </div>
                                    </div>
                                </Fragment>
                            : ""
                        }
                    </div>

                    <div className="card-footer d-flex justify-content-between py-6 px-9">
                        <button type="submit" className="btn btn-danger" onClick={() => { onClickDeleteAllDataExtension() }}  >{t("Delete All Data Extension")}</button>
                        <button type="submit" className="btn btn-primary" onClick={() => { onClickSaveEdit() }}  >{t("Save Changes")}</button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
